import { StudentAbsenteeismReportUIProvider } from "./StudentAbsenteeismReportUIContext";
import { StudentAbsenteeismReportCard } from "./StudentAbsenteeismReportCard";

export function StudentAbsenteeismReportPage() {
  return (
    <StudentAbsenteeismReportUIProvider>
      <StudentAbsenteeismReportCard />
    </StudentAbsenteeismReportUIProvider>
 );
}